import React from 'react';
import { DataTable } from '@contently/toolkit';

const PreviewTableWrapper = props => {
  const { csvData } = props;

  const TagsCell = ({ tags }) =>
    tags.map(tagGroup => {
      if (tagGroup.tags.length > 0) {
        return (
          <p key={tagGroup.tagGroupName}>
            {`${tagGroup.tagGroupName}: ${tagGroup.tags.join(', ')}`}
          </p>
        );
      }
      return null;
    });
  const columns = [
    {
      Header: 'Id',
      accessor: 'storyId',
      width: 100,
      filter: {
        type: 'search',
        placeholder: 'Search id'
      }
    },
    {
      Header: 'Title',
      accessor: 'storyTitle',
      filterOptions: {
        type: 'search',
        placeholder: 'Search title'
      },
      filter: DataTable.filterByContaining('storyTitle')
    },
    {
      Header: 'Tags To Add',
      accessor: d => d.tagsToAdd,
      Cell: cell => <TagsCell tags={cell.row.original.tagsToAdd} />
    },
    {
      Header: 'Existing Tags',
      accessor: d => d.existingTags,
      Cell: cell => <TagsCell tags={cell.row.original.existingTags} />
    },
    {
      Header: 'Invalid Tags',
      accessor: d => d.invalidTags,
      Cell: cell => <TagsCell tags={cell.row.original.invalidTags} />
    }
  ];

  return <DataTable.Table data={csvData} columns={columns} />;
};

export default PreviewTableWrapper;



// WEBPACK FOOTER //
// ./app/javascript/app/components/admin2/bulk_story_tagging/preview_table_wrapper.jsx